module.exports = __webpack_public_path__ + "626f543f3736b61dbb2410a79e890966.svg";